export default __webpack_public_path__ + "static/media/11.ac24d028.jpg";